import { Draft } from '@reduxjs/toolkit';
import { IClipboardState } from './clipboardSlice';

export function applyPasteLayersToPasteCountReducer(state: Draft<IClipboardState>) {
  ++state.pasteCount;
}
